/* src/app/components/header/header.component.scss */
.header {
  width: 100%;
  height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-inline: 14px;
  background: var(--color-background-alt);
  border-bottom: 1px solid #272727;
}
.header .type-row {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
}
.header .type-block {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
}
.header .type-block .button-type {
  min-width: 88px;
  min-height: 30px;
  font-size: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--color-black);
  background: transparent;
  border-radius: 26px;
  text-transform: uppercase;
  background: #ebdfda;
}
.header .type-block .button-type.selected {
  background: var(--ion-color-primary);
  color: white !important;
}
.header .title {
  width: 100%;
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 8%;
  text-align: center;
  text-transform: uppercase;
  padding-bottom: 10px;
  border-bottom: 1px solid #B5B5B5;
}
/*# sourceMappingURL=header.component.css.map */
